import React from "react";
import LegalDocumentPage from "./LegalDocumentPage";
import { relatedLegalLinks, LEGAL_SHARED } from "../config/legal";
import { SITE } from "../config/site";

const bullets = (items) => ({ type: "bullets", items });

export default function RefundPolicyPage() {
  const sections = [
    {
      id: "scope",
      title: "1. Scope",
      blocks: [
        `This Refund Policy applies to ${LEGAL_SHARED.product} subscriptions sold by ${LEGAL_SHARED.entity}.`,
        LEGAL_SHARED.sellers,
        LEGAL_SHARED.simulation,
        LEGAL_SHARED.noLiveTrading,
      ],
    },
    {
      id: "voluntary",
      title: "2. Voluntary refunds",
      blocks: [
        "This voluntary refund policy is a founder draft pending approval. Stratify considers voluntary refund requests case by case. A purchase is not automatically refundable because you cancelled, unused time remains, or results disappointed you.",
        `To request a voluntary refund, email ${SITE.supportEmail} with the email on your Stratify account, an invoice or order reference if you have one, whether you purchased through Stripe or Apple, and the reason.`,
        "Never email card numbers, bank details, passwords, one-time codes, or API keys.",
        "Cancellation and a refund are separate actions. Cancelling stops future renewal; it does not by itself create a refund.",
        "We do not promise a processing deadline or a guaranteed refund.",
      ],
    },
    {
      id: "apple",
      title: "3. Apple purchases",
      blocks: [
        "Apple bills App Store subscriptions. You may also request a refund from Apple using Apple’s subscription or report-a-problem tools.",
        { type: "link", href: SITE.appleSubscriptionsUrl, label: "Manage Apple subscriptions" },
      ],
    },
    {
      id: "stripe",
      title: "4. Stripe / website purchases",
      blocks: [
        "Stripe processes website Checkout. After website Checkout is available, you can manage payment methods and invoices in the Stripe Customer Portal from the pricing page while signed in.",
        "Website Checkout is not open for public purchases until Stratify enables it.",
      ],
    },
    {
      id: "rights",
      title: "5. Mandatory consumer rights",
      blocks: [
        "Nothing in this policy limits refund, cancellation, or other rights you have under applicable consumer law. If a law requires a refund, that requirement controls.",
      ],
    },
    {
      id: "chargebacks",
      title: "6. Card disputes",
      blocks: [
        "A card dispute opened with your bank or card issuer is not a Stratify voluntary refund. Contact support first when you can so we can look up the purchase.",
      ],
    },
    {
      id: "how-to",
      title: "7. What to include",
      blocks: [
        bullets([
          "The email on your Stratify account",
          "Invoice or order reference, if you have one",
          "Purchase source: Stripe website or Apple App Store",
          "Why you are requesting a refund",
        ]),
        { type: "internalLink", to: "/support", label: "Contact support" },
      ],
    },
  ];

  return (
    <LegalDocumentPage
      badge="Refund Policy"
      title="Refund Policy"
      description="How Stratify considers refund requests for Stripe and Apple subscriptions, and how mandatory consumer rights are preserved."
      sections={sections}
      relatedLinks={relatedLegalLinks("/refund-policy")}
      path="/refund-policy"
    />
  );
}
